module.exports = __webpack_public_path__ + "static/media/smile-beam.55f13bbf.svg";